<template>
    <div class="l-ss-c-age-check-popup-wrapper-mask">
        <popup
            :title="$t('ageCheckPopup.title', [18])"
            :opened="isShow"
            class="l-ss-c-age-check-popup"
            @close="onDeny">
            <div class="l-ss-c-age-check-popup-content">
                <p>{{ $t('ageCheckPopup.info') }}</p>
                <p>{{ $t('ageCheckPopup.isAdult', [18]) }}</p>
                <div class="l-ss-c-age-check-popup-buttons">
                    <button
                        class="l-ss-c-button l-ss-c-age-check-popup-button"
                        @click="onConfirm">
                        {{ $t('ageCheckPopup.confirm') }}
                    </button>
                    <button
                        class="l-ss-c-button l-ss-c-age-check-popup-button l-ss-c-button-outline"
                        @click="onDeny">
                        {{ $t('ageCheckPopup.deny') }}
                    </button>
                </div>
            </div>
        </popup>
    </div>
</template>

<script>
    import Popup from './popup';
    import { setCookie } from '/src/core/helpers/cookies';

    export default {
        components: {
            Popup,
        },
        props: {
            isShow: {
                type: Boolean,
                default: false,
            },
        },
        mounted() {
            document.body.style.overflow = 'hidden';
        },
        beforeDestroy() {
            document.body.style.overflow = null;
        },
        methods: {
            onConfirm() {
                setCookie(this.$configuration.ageCheckPopupCookieName, true);
                this.$emit('close');
            },
            onDeny() {
                setCookie(this.$configuration.ageCheckPopupCookieName, false);
                this.$emit('deny');
                this.$emit('close');
            },
        },
    };
</script>